import React from "react";
import {
  Typography,
  RadioGroup,
  Divider,
  Grid,
  TextField,
  Button,
  withStyles,
  FormControlLabel,
  Radio,
  MenuItem,
  Icon,
  FormControl,
  FormGroup,
  Checkbox
} from "material-ui";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { NetScanEnum } from "./netscanenum";
import { validateFormData } from "../../../common/formtool";

class NetScan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      netScanSettingType: "",
      isChanged: false,
      showConfirmBack: false,
      ipAddress: "",
      scanRange: [],
      startAddress: "",
      endAddress: "",
      targetDisable: false,
      addressRangeDisable: false,
      errors: {},
      defaultIPAddress: "",
      defaultStartAddress: "",
      defaultEndAddress: "",
      showRestoreConfirm: false,
      isNetScanUpdated: false,
      ipv6_scan: false,
      netScanInitialized: false
    };
  }

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false
    });
    this.onNetScanSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  getEnumValue = value => {
    let selectedEnum = NetScanEnum.filter(scanEnum => scanEnum.value === value);
    return selectedEnum;
  };

  updateIpv4state = netScan => {
    if (netScan.localnetscansetup && parseInt(netScan.scanrange) !== 3) {
      this.setState({
        netScanSettingType: "local",
        ipAddress: netScan.ipaddress,
        scanRange: this.getEnumValue(netScan.scanrange),
        startAddress: netScan.startaddress,
        endAddress: netScan.endaddress,
        targetDisable: true,
        addressRangeDisable: true,
        defaultIPAddress: netScan.ipaddress,
        defaultStartAddress: netScan.startaddress,
        defaultEndAddress: netScan.endaddress,
        ipv6_scan : netScan.ipv6_scan === 0 ? false : true
      });
    } else if (netScan.localnetscansetup && parseInt(netScan.scanrange) === 3) {
      this.setState({
        netScanSettingType: "local",
        ipAddress: netScan.ipaddress,
        scanRange: this.getEnumValue(netScan.scanrange),
        startAddress: netScan.startaddress,
        endAddress: netScan.endaddress,
        targetDisable: true,
        addressRangeDisable: false,
        defaultIPAddress: netScan.ipaddress,
        defaultStartAddress: netScan.startaddress,
        defaultEndAddress: netScan.endaddress,
        ipv6_scan : netScan.ipv6_scan === 0 ? false : true
      });
    } else if (
      !netScan.localnetscansetup &&
      parseInt(netScan.scanrange) !== 3
    ) {
      this.setState({
        netScanSettingType: "custom",
        ipAddress: netScan.ipaddress,
        scanRange: this.getEnumValue(netScan.scanrange),
        startAddress: netScan.startaddress,
        endAddress: netScan.endaddress,
        targetDisable: false,
        addressRangeDisable: true,
        defaultIPAddress: netScan.ipaddress,
        defaultStartAddress: netScan.startaddress,
        defaultEndAddress: netScan.endaddress,
        ipv6_scan : netScan.ipv6_scan === 0 ? false : true
      });
    } else if (
      !netScan.localnetscansetup &&
      parseInt(netScan.scanrange) === 3
    ) {
      this.setState({
        netScanSettingType: "custom",
        ipAddress: netScan.ipaddress,
        scanRange: this.getEnumValue(netScan.scanrange),
        startAddress: netScan.startaddress,
        endAddress: netScan.endaddress,
        targetDisable: false,
        addressRangeDisable: false,
        defaultIPAddress: netScan.ipaddress,
        defaultStartAddress: netScan.startaddress,
        defaultEndAddress: netScan.endaddress,
        ipv6_scan : netScan.ipv6_scan === 0 ? false : true
      });
    }
  };

  onChange = e => {
    const {
      netScan,
      defaultIPAddress,
      defaultStartAddress,
      defaultEndAddress,
      ipAddress,
      startAddress,
      endAddress
    } = this.state;
    let validateErrors = this.state.errors;
    const { translate } = this.props;
    if (e.target.name === "netScanSettingType" && e.target.value === "local") {
      delete validateErrors["ipAddress"];
      let validationObj = {
        ipAddress: {
          validIPAddress: translate("valid_ip_address")
        }
      };
      let errors = validateFormData({ ipAddress }, validationObj);
      if (Object.keys(errors).length) {
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          targetDisable: true,
          ipAddress: defaultIPAddress,
          errors: validateErrors
        });
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          targetDisable: true,
          errors: validateErrors
        });
      }
    } else if (e.target.name === "netScanSettingType") {
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        targetDisable: false,
        errors: validateErrors
      });
    } else if (
      e.target.name === "scanRange" &&
      parseInt(e.target.value) === 3
    ) {
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        addressRangeDisable: false,
        errors: validateErrors
      });
    } else if (
      e.target.name === "scanRange" &&
      parseInt(e.target.value) !== 3
    ) {
      let validationObj = {
        startAddress: {
          validIPAddress: translate("valid_ip_address")
        },
        endAddress: {
          validIPAddress: translate("valid_ip_address")
        }
      };
      let errors = validateFormData(
        { startAddress, endAddress },
        validationObj
      );
      if (
        Object.keys(errors).length &&
        errors.endAddress &&
        errors.startAddress
      ) {
        delete validateErrors.endAddress;
        delete validateErrors.startAddress;
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          addressRangeDisable: true,
          startAddress: defaultStartAddress,
          endAddress: defaultEndAddress,
          errors: validateErrors
        });
      } else if (Object.keys(errors).length && errors.startAddress) {
        delete validateErrors.startAddress;
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          addressRangeDisable: true,
          startAddress: defaultStartAddress,
          errors: validateErrors
        });
      } else if (Object.keys(errors).length && errors.endAddress) {
        delete validateErrors.endAddress;
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          addressRangeDisable: true,
          endAddress: defaultEndAddress,
          errors: validateErrors
        });
      } else {
        this.setState({
          [e.target.name]: e.target.value,
          isChanged: true,
          addressRangeDisable: true,
          errors: validateErrors
        });
      }
    } else if(e.target.name === "ipv6_scan") {
      delete validateErrors[e.target.name];
      this.setState({
        [e.target.name]: !this.state.ipv6_scan,
        isChanged: true,
        errors: validateErrors
      });
    } else {
      delete validateErrors[e.target.name];
      this.setState({
        [e.target.name]: e.target.value,
        isChanged: true,
        errors: validateErrors
      });
    }
    this.setState({ isRestore: false });
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };

  onRestoreConfirm = () => {
    // this.props.updateNetScan(this.props.selectedTest, this.props.netScan);
    this.updateIpv4state(this.props.netScan);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  onNetScanSave = () => {
    const {
      netScanSettingType,
      ipAddress,
      scanRange,
      startAddress,
      endAddress,
      ipv6_scan
    } = this.state;
    const { translate, isTestEdit } = this.props;

    let validationObj = {
      ipAddress: {
        validIPAddress: translate("valid_ip_address")
      },
      startAddress: {
        validIPAddress: translate("valid_ip_address")
      },
      endAddress: {
        validIPAddress: translate("valid_ip_address")
      }
    };

    let errors = validateFormData(
      { ipAddress, startAddress, endAddress },
      validationObj
    );

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      const payload = {
        localnetscansetup: netScanSettingType === "local",
        ipaddress: ipAddress,
        scanrange:
          scanRange && scanRange.length ? scanRange[0].value : scanRange,
        startaddress: startAddress,
        endaddress: endAddress,
        ipv6_scan : ipv6_scan ? 1 : 0
      };
      if (isTestEdit) {
        this.props.updateNetScan(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateNetScan(payload);
      }
      if (this.state.isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
      this.setState({
        isChanged: false,
        errors: {},
        defaultIPAddress: ipAddress,
        defaultStartAddress: startAddress,
        defaultEndAddress: endAddress
      });
    }
  };

  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      netscandetails,
      netScan,
      testEdit,
      modified
    } = this.props;
    const {
      netScanSettingType,
      showConfirmBack,
      isChanged,
      ipAddress,
      scanRange,
      startAddress,
      endAddress,
      addressRangeDisable,
      targetDisable,
      errors,
      isRestore,
      ipv6_scan
    } = this.state;
    return (
      <div display="flex" flexdirection="row" p={1} m={1}  style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("netscan_setup")}
          />
        )}
        <Content translate={translate}>
          {netScan &&
            (netScanSettingType === "local" ||
              netScanSettingType == "custom") && (
              <Grid container>
                <Grid item xs={isTestEdit ? 0 : 2}></Grid>
                <Grid item xs={isTestEdit ? 12 : 8}>
                  <Typography variant={"h1"} type={"title"}>
                    {translate("ipv4_netscan_setup")}
                  </Typography>
                  <br />
                  <Divider />
                  <RadioGroup
                    aria-label=""
                    name="netScanSettingType"
                    value={netScanSettingType}
                    onChange={this.onChange}
                  >
                    <FormControlLabel
                      value={"local"}
                      control={<Radio />}
                      label="Local"
                    />
                    <FormControlLabel
                      value={"custom"}
                      control={<Radio />}
                      label="Custom"
                    />
                  </RadioGroup>
                  <Grid container>
                    <Grid item xs={8}>
                      <TextField
                        className={classes.textField}
                        error={errors.ipAddress}
                        name="ipAddress"
                        label={translate("ip_address")}
                        margin="normal"
                        value={ipAddress}
                        onChange={this.onChange}
                        fullWidth
                        disabled={targetDisable}
                        helperText={
                          errors.ipAddress ? translate("valid_ip_address") : ""
                        }
                      />
                      <TextField
                        select
                        name={"scanRange"}
                        value={
                          scanRange && scanRange.length
                            ? scanRange[0].value
                            : scanRange
                        }
                        onChange={this.onChange}
                        error={false}
                        label={translate("scan_range")}
                        margin="normal"
                        fullWidth
                      >
                        {NetScanEnum.map(netScan => {
                          return (
                            <MenuItem key={netScan.key} value={netScan.value}>
                              {netScan.key}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                      <TextField
                        className={classes.textField}
                        error={errors.startAddress}
                        name="startAddress"
                        label={translate("start_address")}
                        margin="normal"
                        value={startAddress}
                        onChange={this.onChange}
                        fullWidth
                        disabled={addressRangeDisable}
                        helperText={
                          errors.startAddress
                            ? translate("valid_ip_address")
                            : ""
                        }
                      />
                      <TextField
                        className={classes.textField}
                        error={errors.endAddress}
                        name="endAddress"
                        label={translate("end_address")}
                        margin="normal"
                        value={endAddress}
                        onChange={this.onChange}
                        fullWidth
                        disabled={addressRangeDisable}
                        helperText={
                          errors.endAddress ? translate("valid_ip_address") : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={4}></Grid>
                  </Grid>
                  <br />
                  <Typography type="title">
                    {translate("ipv6_netscan_setup")}
                  </Typography>
                  <br />
                  <Divider />                  
                  <FormControl fullWidth margin="normal" error={false}>
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={ipv6_scan}
                                onChange={this.onChange}
                                name="ipv6_scan"
                              />
                            }
                            label={translate("piv6_scan_enabled")}
                          />
                        </FormGroup>
                      </FormControl>
                  <br />
                  <Divider />
                  <br />
                  {!isTestEdit && (
                    <div align="right">
                      <Button
                        className={classes.saveTarget}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={this.onNetScanSave}
                      >
                        {translate("sub_set_ping_save_target")}
                      </Button>
                    </div>
                  )}
                </Grid>
                <Grid item xs={isTestEdit ? 0 : 2}></Grid>
              </Grid>
            )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: translate("netscan")
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={
                testEdit ? translate("test_edit_title") : translate("test_add")
              }
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit &&
          (netScanSettingType === "local" ||
            netScanSettingType == "custom") && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "inline-block", marginLeft: "20px" }}>
                {netscandetails && !testEdit ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : testEdit && modified ? (
                  <Button
                    className={classes.restoreButton}
                    disabled={isRestore}
                    color="primary"
                    onClick={() => this.onResetDetails()}
                  >
                    <Icon> restore </Icon>{" "}
                    {translate("restore_default_settings")}
                  </Button>
                ) : null}
              </div>
              <div style={{ display: "inline-block", marginRight: "20px" }}>
                <Button
                  className={classes.saveTarget}
                  disabled={!isChanged}
                  color="accent"
                  raised
                  onClick={() => this.onNetScanSave()}
                >
                  {translate("general_continue")}
                </Button>
              </div>
            </div>
          )}
      </div>
    );
  }

  // component life cycles
  componentWillMount() {
    const { getNetScan, netScan } = this.props;
    getNetScan();
  }

  componentWillReceiveProps(nextProps) {
    const { netScanInitialized } = this.state
    const { netScan, netscandetails, isTestEdit } = nextProps;
    if (isTestEdit && !netscandetails) {
      if (netScan && this.props.netScan != netScan && !netScanInitialized) {
        this.setState({ netScanInitialized: true }, this.updateIpv4state(netScan));
      }
    } else if (isTestEdit && netscandetails) {
      if (
        (netscandetails && this.props.netscandetails != netscandetails) ||
        !this.state.isNetScanUpdated
      ) {
        this.updateIpv4state(netscandetails);
        this.setState({ isNetScanUpdated: true });
      }
    } else {
      if (netScan && this.props.netScan != netScan) {
        this.updateIpv4state(netScan);
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }
}

export default withRouter(withStyles(styles)(NetScan));



// WEBPACK FOOTER //
// ./src/components/subtestsetting/netscan/index.js